import React from 'react'
import useForceLogin from '@hooks/useForceLogin'
import useWebsiteId from '@hooks/useWebsiteId'
import Container from '@packages/justo-parts/lib/components/Container'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import Balance from './Balance'
import Redeem from './Redeem'

import styles from './styles.module.css'

export default function RedeemMain(props) {
  useForceLogin()
  const websiteId = useWebsiteId()
  const {me, config} = useQuery({
    query: gql`
      query getPointsconfiguration($websiteId: ID) {
        config: loyaltyProgramConfig(websiteId: $websiteId) {
          active
          name
          accumulationRate
        }
        me {
          _id
          balance: pointsInWebsite(websiteId: $websiteId)
        }
      }
    `,
    variables: {
      websiteId
    }
  })

  if (!config) return null
  return (
    <div className={styles.container}>
      <Container size="medium">
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Balance me={me} config={config} />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Redeem me={me} config={config} />
          </div>
        </div>
      </Container>
    </div>
  )
}
